import { MapPin, Wifi, Leaf, Baby } from "lucide-react";
import { SITE } from "../data/site";
import { useT } from "../i18n/LanguageContext";

export const MapSection = () => {
  const { t } = useT();
  const query = encodeURIComponent("Pizzeria da Sofia, Via XXIII Marzo 1849, 147, 28100 Novara NO");
  const services = [
    { icon: <Leaf className="w-4 h-4" />, label: t("map.svc.veg") },
    { icon: <Wifi className="w-4 h-4" />, label: t("map.svc.wifi") },
    { icon: <Baby className="w-4 h-4" />, label: t("map.svc.kids") },
  ];

  return (
    <section id="mappa" data-testid="map-section" className="py-24 md:py-32 bg-[var(--ivory)]">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-stretch">
          <div className="lg:col-span-5">
            <div className="gold-divider justify-start">
              <span className="line" />
              <span className="text-[11px] tracking-[0.3em] uppercase">{t("map.kicker")}</span>
            </div>
            <h2 className="mt-6 font-display text-5xl md:text-6xl text-[var(--espresso)] tracking-tight-elegant">
              {t("map.titlePre")} <span className="italic font-serif-elegant text-[var(--gold-deep)]">{t("map.titleEm")}</span>
            </h2>
            <p className="mt-5 text-[var(--warm-gray)] leading-relaxed">{t("map.desc")}</p>

            <ul className="mt-8 space-y-4">
              <li className="flex items-start gap-4 border-l border-[var(--gold)]/40 pl-5 py-1">
                <MapPin className="w-5 h-5 text-[var(--gold-deep)] mt-1" />
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--warm-gray)]">{t("map.address")}</div>
                  <div className="font-display text-lg text-[var(--espresso)]">{SITE.address}</div>
                  <div className="text-sm text-[var(--warm-gray)]">{SITE.city}</div>
                </div>
              </li>
            </ul>

            <div className="mt-8">
              <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--warm-gray)] mb-3">{t("map.services")}</div>
              <div className="flex flex-wrap gap-2">
                {services.map((s, i) => (
                  <span key={i} className="inline-flex items-center gap-2 px-3 py-2 border border-[var(--sand)] text-xs text-[var(--espresso-soft)]">
                    {s.icon} {s.label}
                  </span>
                ))}
              </div>
            </div>

            <a
              href={`https://www.google.com/maps?q=${query}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="map-directions-cta"
              className="btn-ghost mt-10"
            >
              {t("map.directions")}
            </a>
          </div>

          <div className="lg:col-span-7">
            <div className="relative h-[420px] lg:h-full min-h-[420px] border border-[var(--sand)] overflow-hidden">
              <iframe
                title="Pizzeria da Sofia — Mappa"
                src={`https://www.google.com/maps?q=${query}&output=embed`}
                width="100%"
                height="100%"
                loading="lazy"
                style={{ border: 0, filter: "saturate(0.9) contrast(1.02)" }}
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                data-testid="map-iframe"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
